var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3252 12.3333C8.3252 10.1196 10.1198 8.32495 12.3335 8.32495C14.5472 8.32495 16.3418 10.1196 16.3418 12.3333C16.3418 14.547 14.5472 16.3416 12.3335 16.3416C10.1198 16.3416 8.3252 14.547 8.3252 12.3333Z",
    fill: "#818090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 24.6666C19.1448 24.6666 24.6666 19.1448 24.6666 12.3333C24.6666 5.52181 19.1448 0 12.3333 0C5.52181 0 0 5.52181 0 12.3333C0 19.1448 5.52181 24.6666 12.3333 24.6666ZM12.3333 6.47499C9.09785 6.47499 6.47499 9.09785 6.47499 12.3333C6.47499 15.5688 9.09785 18.1916 12.3333 18.1916C15.5688 18.1916 18.1916 15.5688 18.1916 12.3333C18.1916 9.09785 15.5688 6.47499 12.3333 6.47499Z",
    fill: "#818090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.e3cf2802e9763f9df07cca7301c5f9e4.svg";
export { ForwardRef as ReactComponent };